module.exports = function (data) {
    const event = {
        event: 'BWSAUproductList',
        eventContext: {
            pid_list: data.pidList
        }
    };

    return event;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/categories/atm/product-list-mapper.js
 **/